import React from 'react';
import { TYPES } from '../../config/consignments';
import Consignment from '../../containers/Consignment';

export default function OutboundConsignment() {
  return <Consignment type={TYPES.OUTBOUND} />;
}
